/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-09-13 14:13:55
 *
 *******************************************************/
// @flow

import { getJSON } from 'redux-api-middleware';
import { I18n } from '@shopify/react-i18n';
import { processRes } from 'src/helpers/actions-helper';

import apiService from 'src/services/api-service';
import {
  VERIFY_DISCOUNT_CODE_REQUEST,
  VERIFY_DISCOUNT_CODE_SUCCESS,
  VERIFY_DISCOUNT_CODE_FAILURE,
  SUBSCRIBE_PLAN_REQUEST,
  SUBSCRIBE_PLAN_SUCCESS,
  SUBSCRIBE_PLAN_FAILURE,
  ACTIVATE_CHARGE_REQUEST,
  ACTIVATE_CHARGE_SUCCESS,
  ACTIVATE_CHARGE_FAILURE,
  CLEAR_DISCOUNT_CODE
} from 'stores/flow-type/subscription.type';

/**
 * call to verify discount code
 * @return {object} The RSAA object for API middleware
 */
export const verifyDiscountCode = code => {
  return apiService.sendRequest('admin-v3.discount-code.verify', { body: { code } }, [
    VERIFY_DISCOUNT_CODE_REQUEST,
    {
      type: VERIFY_DISCOUNT_CODE_SUCCESS,
      payload: async (action, state, res) => {
        const data = await getJSON(res);

        return { data };
      }
    },
    {
      type: VERIFY_DISCOUNT_CODE_FAILURE,
      payload: async (action, state, res) => {}
    }
  ]);
};

/**
 * call to subscribe a plan
 * @return {object} The RSAA object for API middleware
 */
export const subscribe = (planId: string, code: string, host, i18n: I18n) => {
  const params = { planId };
  // Prepare Body
  const dataBody = { discountCode: code, host };

  return apiService.sendRequest('admin-v3.subscription.subscribe', { params, body: dataBody }, [
    SUBSCRIBE_PLAN_REQUEST,
    {
      type: SUBSCRIBE_PLAN_SUCCESS,
      payload: async (action, state, res) => {
        const data = await getJSON(res);

        return { data };
      }
    },
    {
      type: SUBSCRIBE_PLAN_FAILURE,
      payload: async (action, state, res) =>
        await processRes(
          res,
          'error',
          i18n.translate('AdminHTML.Subscription.Actions.subscribe'),
          i18n
        )
    }
  ]);
};

/**
 * call to activate charge
 * @return {object} The RSAA object for API middleware
 */
export const activate = (chargeId: string, i18n: I18n) => {
  const params = { chargeId };

  return apiService.sendRequest('admin-v3.subscription.activate', { params }, [
    ACTIVATE_CHARGE_REQUEST,
    {
      type: ACTIVATE_CHARGE_SUCCESS,
      payload: async (action, state, res) => {
        const data = await getJSON(res);

        return { data };
      }
    },
    {
      type: ACTIVATE_CHARGE_FAILURE,
      payload: async (action, state, res) =>
        await processRes(
          res,
          'error',
          i18n.translate('AdminHTML.Subscription.Actions.activate'),
          i18n
        )
    }
  ]);
};

/**
 * Reset setup feedback state
 * @return {object} The RSAA object for API middleware
 */
export const clearDiscountCode = () => {
  return {
    type: CLEAR_DISCOUNT_CODE,
    payload: {}
  };
};
